'use client';

import { ApiKeys, fetcher } from '@insta-club/api';
import { CloseIcon, VerifyIcon } from '@insta-club/components/icons';
import { PageAccount } from '@insta-club/models';
import { useAccountSwitcherSheetStore, useSessionStore } from '@insta-club/state';
import { Avatar, Button } from '@insta-club/ui';
import { cn, truncateText } from '@insta-club/utilities';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { mutate } from 'swr';
import { Drawer } from 'vaul';

function AccountItem({ data }: { data: PageAccount }) {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const activePageId = useSessionStore((state) => state.activePageId);
    const setActivePage = useSessionStore((state) => state.setActivePage);
    const updateSession = useSessionStore((state) => state.updateSession);

    const accountSwitcherSheetClose = useAccountSwitcherSheetStore((state) => state.closeDrawer);

    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleDeletePage = async () => {
        try {
            setIsLoading(true);
            updateSession();
            await fetcher(ApiKeys.GET_CAN_DELETE_PAGE(data.id), 'dashboard', 'GET').then(async (res) => {
                if (res.ok) {
                    await fetcher(ApiKeys.DELETE_PAGE(data.id), 'dashboard', 'DELETE');
                } else {
                    toast.error(res.msg);
                }

                updateSession();
                mutate(ApiKeys.GET_PAGE_LIST);
            });
        } catch (error) {
            console.log(error);
        } finally {
            setIsLoading(false);
            setIsOpen(false);
        }
    };

    return (
        <>
            <div
                className={cn(
                    'hover:bg-primary-50 hover:border-primary-200 shadow-main flex cursor-pointer items-center justify-between space-x-3 rounded-2xl border-2 border-transparent bg-white px-4 py-3 transition-all ease-in',
                    {
                        'bg-primary-50 border-primary-200': activePageId === data.id
                    }
                )}
            >
                <div
                    onClick={() => {
                        setActivePage(data.id);
                        accountSwitcherSheetClose();
                    }}
                    className='flex h-full w-full items-center gap-3'
                >
                    <Avatar src={data.image} alt={data.page} size={41} />
                    <div className='flex items-center gap-2' style={{ height: 41 }}>
                        <span className='flex h-full items-center text-base leading-none font-bold text-gray-800'>
                            {truncateText(data.page, 15)}
                        </span>

                        {!!data?.subscription && (
                            <span
                                className='bg-secondary-700 flex items-center justify-center rounded-full px-2.5 py-[2px] text-xs leading-none font-semibold text-white'
                                style={{ fontFamily: 'Poppins', height: 20 }}
                            >
                                Pro
                            </span>
                        )}
                    </div>
                </div>

                <div className='flex items-center space-x-3'>
                    {activePageId === data.id && <VerifyIcon />}

                    {/* TODO: uncomment this for remove page action :ilia faramarzpour */}
                    {/* <div
                        onClick={() => {
                            setIsOpen(true);
                        }}
                    >
                        <TrashIcon />
                    </div> */}
                </div>
            </div>

            <Drawer.NestedRoot
                open={isOpen}
                onClose={() => {
                    setIsOpen((prev) => !prev);
                }}
            >
                <Drawer.Portal>
                    <Drawer.Overlay className='absolute inset-0 z-[60] bg-black/40' />
                    <Drawer.Content className='absolute right-0 bottom-0 left-0 z-[60] h-fit rounded-t-xl bg-white px-6 pb-6 outline-none'>
                        <div className='m-auto my-4 h-1.5 w-10 rounded-2xl bg-gray-200' />
                        <div className='mb-5 flex items-center gap-2'>
                            <Drawer.Title className='flex-1 truncate text-base font-bold text-gray-800'>
                                حذف اطلاعات
                            </Drawer.Title>
                            <Drawer.Close className='cursor-pointer text-sm font-normal text-gray-700'>
                                <CloseIcon />
                            </Drawer.Close>
                        </div>
                        <p className='mb-6 text-sm font-normal text-gray-500'>آیا از حذف اکانت خود اطمینان دارید؟</p>
                        <div className='flex items-center justify-between space-x-3'>
                            <Button
                                loading={isLoading}
                                onClick={() => {
                                    handleDeletePage();
                                }}
                                variant='outline'
                                color='danger'
                                fullWidth
                            >
                                بله, حذف میکنم
                            </Button>
                            <Button
                                onClick={() => {
                                    setIsOpen(false);
                                }}
                                variant='light'
                                fullWidth
                                color='gray'
                            >
                                انصراف
                            </Button>
                        </div>
                    </Drawer.Content>
                </Drawer.Portal>
            </Drawer.NestedRoot>
        </>
    );
}

export default AccountItem;

